/**
 * Уход со страницы на чужой адрес (AI-клиент после согласия). Отдельный модуль — чтобы тест
 * мог его подменить: `window.location.assign` в jsdom не настраивается.
 */
export function leaveToUrl(url: string): void {
  window.location.assign(url);
}
